import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import {
  fetchLetterReferTypesInboxStaticsSuccess,
  fetchLetterReferTypesSendBoxStaticsSuccess,
  onGetDmsTreeMenuSuceess,
} from '../actions/LetterReferTypesStatics';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError } from '../../helper/Alert';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';

// Inbox
const getLetterReferInboxTypesStatics = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `instance/GetLetterReferTypesStatics?folderType=InboxReferType`,
  );
};

// SendBox
const getLetterReferSendBoxTypesStatics = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `instance/GetLetterReferTypesStatics?folderType=SendReferType`,
  );
};

function* fetchLetterReferInboxTypesStaticsRequest(): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedLetterReferInboxTypesStatics = yield call(
      getLetterReferInboxTypesStatics,
    );
    yield put(
      fetchLetterReferTypesInboxStaticsSuccess(
        fetchedLetterReferInboxTypesStatics.data,
      ),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchLetterReferInboxTypesStatics() {
  yield takeEvery(
    ActionTypes.GET_Letter_Refer_Inbox_Types_Statics,
    fetchLetterReferInboxTypesStaticsRequest,
  );
}

//SendBox
function* fetchLetterReferSendBoxTypesStaticsRequest(): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedLetterReferTypesStatics = yield call(
      getLetterReferSendBoxTypesStatics,
    );
    yield put(
      fetchLetterReferTypesSendBoxStaticsSuccess(
        fetchedLetterReferTypesStatics.data,
      ),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchLetterReferSendBoxTypesStatics() {
  yield takeEvery(
    ActionTypes.GET_Letter_Refer_SendBox_Types_Statics,
    fetchLetterReferSendBoxTypesStaticsRequest,
  );
}

const getDmsTree = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`instance/GetDmsTreeMenu`);
};

function* fetchDmsTreeRequest(): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedDmsTree = yield call(getDmsTree);
    yield put(onGetDmsTreeMenuSuceess(fetchedDmsTree.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetDmsTree() {
  yield takeEvery(ActionTypes.GET_DMS_TREE_MENU, fetchDmsTreeRequest);
}

export default function* rootSaga() {
  yield all([
    fork(fetchLetterReferInboxTypesStatics),
    fork(fetchLetterReferSendBoxTypesStatics),
    fork(fetDmsTree),
  ]);
}
